/* tslint:disable */
/* eslint-disable */
/**
 * Trust Investigator APP
 * The Law Society Trust Investigation Api with Swagger, Swashbuckle, and API Versioning.
 *
 * OpenAPI spec version: 1.0
 * Contact: hitesh.patel@lawsociety.com.au
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { TrustTeamMemberViewResponse } from '../models';
/**
 * TrustTeamMemberApi - axios parameter creator
 * @export
 */
export const TrustTeamMemberApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TrustTeamMemberGetTrustTeamMemberGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/TrustTeamMember/GetTrustTeamMember`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TrustTeamMemberApi - functional programming interface
 * @export
 */
export const TrustTeamMemberApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TrustTeamMemberGetTrustTeamMemberGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrustTeamMemberViewResponse>> {
            const localVarAxiosArgs = await TrustTeamMemberApiAxiosParamCreator(configuration).apiV1TrustTeamMemberGetTrustTeamMemberGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * TrustTeamMemberApi - factory interface
 * @export
 */
export const TrustTeamMemberApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TrustTeamMemberGetTrustTeamMemberGet(options?: any): AxiosPromise<TrustTeamMemberViewResponse> {
            return TrustTeamMemberApiFp(configuration).apiV1TrustTeamMemberGetTrustTeamMemberGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TrustTeamMemberApi - object-oriented interface
 * @export
 * @class TrustTeamMemberApi
 * @extends {BaseAPI}
 */
export class TrustTeamMemberApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrustTeamMemberApi
     */
    public apiV1TrustTeamMemberGetTrustTeamMemberGet(options?: any) {
        return TrustTeamMemberApiFp(this.configuration).apiV1TrustTeamMemberGetTrustTeamMemberGet(options).then((request) => request(this.axios, this.basePath));
    }
}
